var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { EditBase } from "react-admin";
import { CandidateDataForm } from "./CandidateDataForm";
import { CircularProgress } from "@mui/material";
import { serializeIvrEntityAnnotations } from "@/utils/ivr";
export var EditCandidateData = function (_a) {
    var record = _a.record;
    if (!record) {
        return _jsx(CircularProgress, {});
    }
    var transform = function (data) {
        var _a, _b, _c, _d;
        // save presentation object
        // language_conf
        var enabled_language_codes = [];
        for (var key in data.enabled_languages) {
            if (typeof data.enabled_languages[key] === "boolean" && data.enabled_languages[key]) {
                enabled_language_codes.push(key);
            }
        }
        var language_conf = {
            enabled_language_codes: enabled_language_codes,
        };
        // i18n
        // is alll object, no change needed
        delete data.enabled_languages;
        // The name and alias live only in the presentation (migration 1772358027729).
        var fromPresentationDescription = ((_c = (_b = (_a = data === null || data === void 0 ? void 0 : data.presentation) === null || _a === void 0 ? void 0 : _a.i18n) === null || _b === void 0 ? void 0 : _b.en) === null || _c === void 0 ? void 0 : _c.description) ||
            ((_d = data === null || data === void 0 ? void 0 : data.presentation) === null || _d === void 0 ? void 0 : _d.i18n[Object.keys(data.presentation.i18n)[0]].description) ||
            "";
        data.description = fromPresentationDescription;
        data.annotations = serializeIvrEntityAnnotations(data.annotations);
        return __assign(__assign({}, data), { presentation: __assign(__assign({}, data.presentation), { language_conf: __assign(__assign({}, language_conf), { default_language_code: data.defaultLanguage }) }) });
    };
    return (_jsx(EditBase, { redirect: ".", transform: transform, children: _jsx(CandidateDataForm, { record: record }) }));
};
